const primary = '#ff4612';
const dark = '#333f48';

export default {
  primary,
  dark,
}
